import axios from '../../functions/axios';
import { useMemo } from 'react';
import {
  Box,
  Grid,
} from '@mui/material';

const LabeledItem = (props) => {
  return (
    <Box style={{ display: 'flex', justifyContent: 'space-between', color: 'white', minWidth: '225px' }}>
      <span>
        <b>{props.label}:</b>
      </span>
      <span>{props.value}</span>
    </Box>
  );
};

const GeneralStatistics = ({ data, dayStart, dayEnd }) => {
  const values = useMemo(() => {
    return data.reduce((acc, value) => {
      if (!value.currency) return acc;
      if (value.currency === 'PLN') {
        acc.costPln += value.cost;
      }
      if (value.currency === 'EUR') {
        acc.costEur += value.cost;
      }
      return acc;
    }, { costPln: 0, costEur: 0 })
  }, [data, dayStart, dayEnd]);

  return (
    <Grid>
      <Box>
        <LabeledItem label='Wykonane transporty' value={data.length}/>
      </Box>
      <Box>
        <LabeledItem label='Suma' value={values.costPln.toFixed(2) + ' zł'}/>
      </Box>
      <Box>
        <LabeledItem label='Suma' value={values.costEur.toFixed(2) + ' €'}/>
      </Box>
    </Grid>
  );
};

export { GeneralStatistics };
